(() => {
  // Format input value
  function formatText(input) {
    if (!input?.type) return;

    // Skip password fields - even when toggled to text type
    if (input.classList.contains('password-field')) return;

    if (input.type === 'email') {
      input.value = input.value.toLowerCase();
      return;
    }

    if (!['text', 'tel'].includes(input.type) || !input.value) return;

    input.value = input.value.split(' ')
      .map(word => {
        if (!word) return word;
        const firstChar = word[0];
        if (firstChar === 'i' || firstChar === 'İ') {
          return firstChar + word.slice(1).toLowerCase();
        }
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }

  // Format all matching inputs
  function formatAllInputs() {
    document.querySelectorAll('input[type="text"], input[type="tel"], input[type="email"]')
      .forEach(input => {
        // Skip password fields even when they're temporarily type="text"
        if (!input.classList.contains('password-field')) {
          formatText(input);
        }
      });
  }

  // Event handlers
  const handlers = {
    input: e => e.target.tagName === 'INPUT' && formatText(e.target),
    blur: e => e.target.tagName === 'INPUT' && formatText(e.target),
    click: e => {
      const buyTrigger = e.target.closest('[data-action="quick-buy"], [data-quick-buy], [name="checkout"], [name="goto_pp"], [name="goto_gc"], .shopify-payment-button, [data-action="add-to-cart"]');
      if (buyTrigger) {
        setTimeout(formatAllInputs, 500);
      }
    }
  };

  // Add event listeners
  Object.entries(handlers).forEach(([event, handler]) => {
    document.addEventListener(event, handler, true);
  });

  // Watch for dynamic content
  new MutationObserver(mutations => {
    if (mutations.some(m => m.addedNodes.length)) {
      setTimeout(formatAllInputs, 100);
    }
  }).observe(document.body, {
    childList: true,
    subtree: true
  });

  // Handle Shopify events
  ['shopify:section:load', 'shopify:block:select', 'page:load', 'page:change', 'cart:refresh', 'template:rendered']
    .forEach(event => document.addEventListener(event, formatAllInputs));

  // Initial format and load handlers
  document.addEventListener('DOMContentLoaded', formatAllInputs);
  window.addEventListener('load', formatAllInputs);
  window.addEventListener('pageshow', formatAllInputs);
})();
